import {io} from 'socket.io-client';

let socketInstance: ReturnType<typeof io> | null = null;
let cachedUrl: string | null = null;

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

const getCookie = (name: string): string | undefined =>
  document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
    ?.split('=')[1];

export const getLeaderboardSocket = () => {
  if (typeof window === 'undefined') return null;

  const baseUrl = API_URL.endsWith('/api') ? API_URL.slice(0, -4) : API_URL;
  const socketUrl = `${baseUrl}/leaderboard`;
  const accessToken = getCookie('ACCESS_TOKEN');
  const celebToken = getCookie('CELEB_ADMIN_TOKEN');
  // Disconnect old socket if URL changed
  if (socketInstance && cachedUrl !== socketUrl) {
    socketInstance.disconnect();
    socketInstance = null;
  }

  if (!socketInstance) {
    socketInstance = io(socketUrl, {
      transports: ['websocket'],
      withCredentials: true,
      auth: {token: accessToken || celebToken},
    });
    socketInstance.on('connect_error', err => {
      console.error('❌ Leaderboard socket connect error: %s', err);
    });
    cachedUrl = socketUrl;
  }

  return socketInstance;
};
